'use client';

import { useState } from 'react';
import type { PickupPointsSearch } from '../utils/getPickupPoints';

interface UsePickupPointListSearchOptions extends PickupPointsSearch {
  isOpen: boolean;
}

/**
 * Resolves the search the pickup-point list loads for: the city and zip shown in the form when the list opens.
 * It stays frozen while open, because selecting a station overwrites city and zip and must not reload the closing list.
 * @returns The search to load.
 */
export function usePickupPointListSearch({ city, zip, isOpen }: UsePickupPointListSearchOptions) {
  const [search, setSearch] = useState<PickupPointsSearch>({ city, zip });
  const hasSearchChanged = search.city !== city || search.zip !== zip;

  if (!isOpen && hasSearchChanged) {
    setSearch({ city, zip });
  }

  return search;
}
